import React, { useState } from "react";
import { isLoggedIn, loginUser } from "../../../utils/auth";
import { Navigate, useLocation } from "react-router-dom";
import { mentorLogin } from "../../../services/userService";

export default function MentorLogin() {
  const loggedIn = isLoggedIn();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Prevent accessing login if already logged in
  if (location.pathname === "/expert-view/login" && loggedIn) {
    return <Navigate to="/expert-view" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await mentorLogin(email, password);
    if (res.status == "success") {
      loginUser(res.data);
      setLoading(false);
      return <Navigate to="/expert-view" replace />;
    } else {
      setLoading(false);
      alert("Login Error" + res.message);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gray-100">
      <div className="w-full max-w-md mx-auto bg-white shadow-xl rounded-2xl p-8">
        <h2 className="text-2xl font-bold text-center mb-6">Mentor Login</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="mentor@example.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        <p className="text-sm text-center text-gray-500 mt-4">
          Forgot password?{" "}
          <span className="text-blue-600 cursor-pointer">Reset</span>
        </p>
      </div>
    </div>
  );
}
